import React, { useState } from 'react';
import { Leaf, Droplets, Sun } from 'lucide-react';

const NotificationScreen = ({ setActiveScreen }) => {
    const [notificationsCards, setnotificationsCards] = useState([
        {
            id: 1,
            title: "Época de poda!",
            content: "Sua Seringueira está em época de poda! Já contratou um de nossos especialistas?",
            date: "05/04/2025",
            time: "16:00",
            baseColor: "green",
            icon: <Leaf />
        },
        {
            id: 2,
            title: "Hora de regar!",
            content: "Já lembrou de irrigar suas plantas hoje?",
            date: "06/04/2025",
            time: "10:00",
            baseColor: "blue",
            icon: <Droplets />
        },
        {
            id: 3,
            title: "Sol forte!",
            content: "Tome cuidado para suas plantas não ficarem ressecadas!",
            date: "07/04/2025",
            time: "12:00",
            baseColor: "amber",
            icon: <Sun />
        }
    ]);
  
    // Função para remover um card da lista
    const handleRemoveCard = (idToRemove) => {
        setnotificationsCards(notificationsCards.filter(item => item.id !== idToRemove));
    };
    
    return (
        <div className="flex flex-col gap-6 w-full">
          {/* Título "Notificações" */}
            <h1 className="text-3xl font-bold text-green-800 mt-[3%] mb-6 ml-[4%]">Notificações</h1>
          {notificationsCards.map((card) => (
            <RetangularCard 
              key={card.id}
              id={card.id}
              title={card.title}
              content={card.content}
              date={card.date}
              icon={card.icon}
              time={card.time}
              baseColor={card.baseColor}
              onRemove={handleRemoveCard}
            />
          ))}
        </div>
      );

    // Componente individual do card
    function RetangularCard({ id, title, content, date, time, icon, onRemove, baseColor }) {
        const colorMap = {
            green: {
              bg: "bg-green-50",
              iconBg: "bg-green-100",
              iconColor: "text-green-600",
              titleColor: "text-green-800",
              textColor: "text-green-600",
              buttonBg: "bg-green-100",
              buttonColor: "text-green-700",
              buttonHover: "hover:bg-green-200",
              closeColor: "text-green-700",
              closeHover: "hover:text-green-900"
            },
            blue: {
              bg: "bg-blue-50",
              iconBg: "bg-blue-100",
              iconColor: "text-blue-600",
              titleColor: "text-blue-800",
              textColor: "text-blue-600",
              buttonBg: "bg-blue-100",
              buttonColor: "text-blue-700",
              buttonHover: "hover:bg-blue-200",
              closeColor: "text-blue-700",
              closeHover: "hover:text-blue-900"
            },
            amber: {
              bg: "bg-amber-50",
              iconBg: "bg-amber-100",
              iconColor: "text-amber-600",
              titleColor: "text-amber-800",
              textColor: "text-amber-600",
              buttonBg: "bg-amber-100",
              buttonColor: "text-amber-700",
              buttonHover: "hover:bg-amber-200",
              closeColor: "text-amber-700",
              closeHover: "hover:text-amber-900"
            }
          };
    
        // Obter as classes de cor do mapa ou usar verde como padrão
        const colors = colorMap[baseColor] || colorMap.green;

        return (
            <div className={`flex items-center justify-between ${colors.bg} rounded-xl shadow-sm p-4 px-6 ml-[2%] w-[97%] relative`}>
              {/* Botão X posicionado absolutamente no canto */}
              <button 
                onClick={() => onRemove(id)}
                className={`absolute top-1 right-1 w-6 h-6 flex items-center justify-center ${colors.closeColor} ${colors.closeHover} rounded-full text-sm`}
                aria-label="Fechar alerta"
              >
                X
              </button>
              
              {/* Seção esquerda - Ícone */}
              <div className="flex-shrink-0 mr-4">
                <div className={`${colors.iconBg} ${colors.iconColor} p-3 rounded-lg`}>
                  {icon}
                </div>
              </div>
              
              {/* Seção central - Conteúdo */}
              <div className="flex-grow mr-4">
                <div className="flex justify-between items-center">
                  <h3 className={`${colors.titleColor} font-medium`}>{title}</h3>
                  <div className={`${colors.textColor} text-xs`}>
                    <span>{date}</span> • <span>{time}</span>
                  </div>
                </div>
                <p className={`${colors.textColor} text-sm mt-1`}>{content}</p>
              </div>
              
            </div>
          );
    }

}

export default NotificationScreen;
